<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons success">login</span>
        <span class="soc-panel-h"> {{'TRANSFER.INCOMING_TRANSFER_RECEIPT' | translate}}</span>
        <span [ngClass]="transfer.statusType == InventoryActionStatus.Pending ? 'soc-pill-lbl soc-green-pill-outline' : 'soc-pill-lbl soc-grey-pill-outline'">{{transfer.statusType}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <form #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24">
        <div class="pos-actions-wrapper">
            <div class="soc-wrapper-gap-24">
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.ISSUED_BY' | translate}}</label>
                    <div class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedByUser?.firstName}} {{transfer.issuedByUser?.lastName}}</span></div>
                </div>
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.ISSUE_DATE' | translate}}</label>
                    <div class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
                </div>
            </div>
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.SOURCE_INVENTORY' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.sourceVenueInventory?.name}}</span></div>
            </div>
        </div>
        <p-table *ngIf="transfer.lineItems" class="soc-borderless-table soc-checkbox-table soc-editable-table" [value]="transfer.lineItems" (onRowSelect)="selectRow($event)" (onRowUnselect)="unselectRow($event)" [(selection)]="receivedItems" [scrollable]="true" scrollHeight="calc(100vh - 462px)">
            <ng-template pTemplate="header">
                <tr>
                    <th [style.max-width]="'48px'"></th>
                    <th [style.max-width]="'138px'">{{'TRANSFER.CODE' | translate}}</th>
                    <th [style.max-width]="'380px'">{{'TRANSFER.ITEM_NAME' | translate}}</th>
                    <th>{{'TRANSFER.QUANTITY' | translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <ng-container formArrayName="items">
                    <tr [formGroupName]="rowIndex">
                        <td [style.max-width]="'48px'">
                            <p-tableCheckbox [value]="item" [index]="rowIndex"></p-tableCheckbox>
                        </td>
                        <td class="secondary-td" [style.max-width]="'138px'">{{item.item.code}}</td>
                        <td [style.max-width]="'380px'">{{item.item.name}}</td>
                        <td>
                            <div class="soc-addon-input-group soc-error-field-wrapper" style="width: 300px">
                                <span *ngIf="getItemControls(rowIndex).controls['quantityReceived'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                                <div class="p-inputgroup">
                                    <input [formControlName]="'quantityReceived'" class="soc-input-text" type="text"
                                        placeholder="{{'TYPE' | translate}}" pInputText  [ngClass]="{'soc-error-active': getItemControls(rowIndex).controls['quantityReceived'].invalid && f.submitted}">
                                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important;" [ngClass]="{'soc-error-active-addon': getItemControls(rowIndex).controls['quantityReceived'].invalid && f.submitted}">{{ item.item ?
                                        (item.item.unitType | unitShortener | lowercase) : "-"}}</span>
                                </div>
                            </div>
                    </tr>
                </ng-container>
            </ng-template>
        </p-table>
        
        <hr class="soc-panel-line"/>
        <div class="d-flex align-items-center justify-content-between">
            <button class="soc-secondary-grey-btn"  type="button" (click)="navigateToMain()"><span class="material-icons-round">arrow_back</span> {{'BACK' | translate}}</button>
            <div class="soc-wrapper-gap-12">
                <button class="soc-secondary-cyan-btn" type="button" (click)="navigateToMain()">{{'CANCEL' | translate}}</button>
                <button class="soc-basic-cyan-btn" type="submit" [disabled]="receivedItems.length == 0" (click)="receiveTransfer()">{{'TRANSFER.RECEIVE_TRANSFER' | translate}}</button>
            </div>
        </div>
    </form>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
